/*jshint ignore:start */
var APP2 = APP2 || {};

(function()
{
	APP2.Abstract = Class.extend(
	{
		init : function()
		{
        	this.$ = {};
			this.events = {};
		},
		
		remove : function()
		{
			this.off();
		},

		//--------  listener
		on : function(name,f)
		{
			this.events[name] = new signals.Signal();
			this.events[name].add(f);
		},

		off : function(name,f)
		{
			if(f != undefined)
			{
				this.events[name].remove(f);
				delete this.events[name];
			}	
			else if( name != undefined)
			{
				this.events[name].removeAll();
				delete this.events[name];
			}	
			else
			{
				for(var name in this.events)
				{
					this.off(name);
				}
			}
		},

		trigger : function(name,obj)
		{
			if( this.events[name] == undefined )
				return;

			this.events[name].dispatch(obj);
		}
	})

})();
/*jshint ignore:start */
var APP2 = APP2 || {};

(function($) {
	APP2.Conf = Class.extend({
		defaults : {
			page : '',
			env : "production",
			baseUrl : null,
			locale : "fr",
			device : "desktop",
			mode : "large",
			isAndroid : navigator.userAgent.toLowerCase().indexOf("android") > -1,
			isiOS : (navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false ),
			// isTouch : Modernizr.touch,
			// overEvent : (Modernizr.touch) ? 'touchstart' : 'mouseover',
			// clickEvent : (Modernizr.touch) ? 'touchstart' : 'click',
			// downEvent : (Modernizr.touch) ? 'touchstart' : 'mousedown',
			// upEvent : (Modernizr.touch) ? 'touchend' : 'mouseup',
			// moveEvent : (Modernizr.touch) ? 'touchmove' : 'mousemove',
			// historyHtml5 : Modernizr.history,
			// hasTransforms : Modernizr.csstransforms,
			// hasTransforms3d : Modernizr.csstransforms3d,
			viewport: {height:0, width:0}
		},

		init : function(options) {
			this.s = $.extend(this.defaults, options);

			this.$ = {
				body : $("body"),
				main : $(".page"),
				html : $('html'),
				win : $(window),
				doc : $(document)
			};

			if (this.s.isTouch) {
				var wh = window.innerHeight;
				var ww = window.innerWidth;
				this.s.viewport.height = wh ? wh : this.$.win.height();
				this.s.viewport.width = ww ? ww : this.$.win.width();
			} else {
				this.s.viewport.height = this.$.win.height();
				this.s.viewport.width = this.$.win.width();
			}

			this.initLog();
		},

		initLog : function() {
			if (this.s.env=="development")
			{
			    window.log = function f(){ log.history = log.history || []; log.history.push(arguments); if(this.console) { var args = arguments, newarr; args.callee = args.callee.caller; newarr = [].slice.call(args); if (typeof console.log === 'object') log.apply.call(console.log, console, newarr); else console.log.apply(console, newarr);}};
			(function(a){function b(){}for(var c="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(","),d;!!(d=c.pop());){a[d]=a[d]||b;}})
			(function(){try{console.log();return window.console;}catch(a){return (window.console={});}}());
			}
			else
			{
			    window.log = function f(){};
			}
		}
	});

})(jQuery);

/**
 * Core
 * Copyright (c) Rosemood, http://www.rosemood.fr/
 *
 * @author      Florent JEAN
 *
 */
'use strict';

var APP2 = APP2 || {};


(function($) {
	APP2.Core = APP2.Abstract.extend( {
		init : function(options) {
			this._super();

			var that = this;

			this.config = new APP2.Conf(options)

      console.log(2);
			if (this.config.s.page === '04b-grand-dome') {
        console.log(3);
				this.page = new APP2.Lac(this.config);
			} else {
				this.page = new APP2.PageAbstract(this.config);
			}

			this.config.$.win.on('resize orientationchange',$.proxy(this.resize, this)).trigger('resize');

			if (this.config.s.isTouch)	{
				FastClick.attach(document.body);
			}

			if (this.page !== null) {
				this.page.startup();
			}
		},

		/* --- listener resize */
		resize : function() {
			var wh = window.innerHeight;
			var ww = window.innerWidth;
			this.config.s.viewport.height = wh ? wh : this.config.$.win.height();
			this.config.s.viewport.width = ww ? ww : this.config.$.win.width();

			this.config.s.mode = 'small';
			if (this.config.s.viewport.width >= 768) {
				this.config.s.mode = 'medium';
			}
			if (this.config.s.viewport.width >= 1008) {
				this.config.s.mode = 'large';
			}
			if (this.config.s.viewport.width >= 1272) {
				this.config.s.mode = 'xlarge';
			}

			if (this.page !== null) {
				this.page.resize();
			}
		}
	});

})(jQuery);

'use strict';
(function($) {
	$('body').addClass('has-js');
})(jQuery);
/**
 * Default
* Copyright (c) Rosemood, http://www.rosemood.fr/
 *
 * @author      Florent JEAN
 *
 */
'use strict';

var APP2 = APP2 || {};

(function($) {
	APP2.PageAbstract = APP2.Abstract.extend({

		/* ==========================================================================
			Data
		========================================================================== */
		data : {

		},

		/* ==========================================================================
			Init
		========================================================================== */
		init: function(config) {
			this._super();

			this.config = config;
		},

		/* ==========================================================================
			Startup
		========================================================================== */
		startup: function() {

		},

		/* ==========================================================================
			Resize
		========================================================================== */
		resize : function() {

		}

	});

})(jQuery);
/**
 * Default
 * Copyright (c) Rosemood, http://www.rosemood.fr/
 *
 * @author      Florent JEAN
 *
 */
'use strict';

var APP2 = APP2 || {};

(function($) {
	APP2.Lac = APP2.PageAbstract.extend({

		/* ==========================================================================
			Defaults
		========================================================================== */
		defaults : {
		},

		/* ==========================================================================
			Init
		========================================================================== */
		init : function(config) {
			this.main = $('#header-3d');
			this.mainWidth = $('#header-3d').width();
			this.mainHeight = $('#header-3d').height();

			this.startWidth = $('.main').width();
			this.startHeight = $('.main').height();

			this._super(config);

			var that = this;

			this.percentX = 1;
			this.percentY = 1;
			this.currentPercentX = 1;
			this.currentPercentY = 1;
			this.scale = 1;

			this.main.on('mousemove touchmove', function (e) {
				var localX = Math.max(typeof e.pageX !== "undefined" ? e.pageX : that.mainWidth, 1);
				var localY = Math.max(typeof e.pageY !== "undefined" ? e.pageY : that.mainHeight, 1);

				that.percentX = ((localX - (that.mainWidth / 2)) / that.mainWidth) * 2;
				that.percentY = ((localY - (that.mainHeight / 2)) / that.mainHeight) * 2;
			}).trigger('mousemove');

			$('.layer').each(function() {
				$(this).css({
					transform: 'translate3d(0, 0, '+$(this).data('z')+'px)'
				});
			});

			 $('#water').lake({
			    'speed': 0.3,
			    'scale': 0.5,
			    'waves': 30
			  });

      console.log(4);
			$('.main').imagesLoaded({background: '.layer'}, function() {
        console.log(5);
				$('.layers').css({
					visibility: 'visible'
				});

			  	$('.main').hide().fadeIn();

			  	$('.loader').hide();
			});
		},

		/* ==========================================================================
			Startup
		========================================================================== */
		startup : function() {
      console.log(6);
			this._super();
			requestAnimationFrame($.proxy(this.animate, this));
		},

		/* ==========================================================================
			Animate
		========================================================================== */
		animate: function() {
			var that = this;

			this.scale += 0.0001;

			this.scale = Math.min(this.scale, 1.25);

			this.currentPercentX += (this.percentX - this.currentPercentX) / 10;
			this.currentPercentY += (this.percentY - this.currentPercentY) / 10;

			// this.currentPercentX = this.percentX;
			// this.currentPercentY = this.percentY;

			$('.layers').css({
				transform: 'translate3d(-50%, -50%, 0) perspective( 1000px ) rotateY('+(this.currentPercentX * -5)+'deg) rotateX('+(this.currentPercentY * -3)+'deg) scale('+this.scale+')'
			});

			$('.layers .layer').each(function() {
				 that.parallax($(this), $(this).data('coeffx'), $(this).data('coeffy'))
			});

			requestAnimationFrame($.proxy(this.animate, this));
		},

		parallax: function(target, coeffX, coeffY) {
			var x = this.currentPercentX * 10 * coeffX;
			var y = this.currentPercentY * 10 * coeffY;

			target.css({
				transform: 'translate3d('+x+'px,'+y+'px, '+target.data('z')+'px)'
			});
		},

		/* ==========================================================================
			Resize
		========================================================================== */
		resize : function() {
			this._super();

			this.mainWidth = $('#header-3d').width();
			this.mainHeight = $('#header-3d').height();

			// Calculate resize ratios for resizing
			var ratioW = this.mainWidth / this.startWidth;
			var ratioH = this.mainHeight / this.startHeight;

			var ratio = ratioW < ratioH?ratioH:ratioW;

			$('.main').css({
				position: 'absolute',
				top: (this.mainHeight - this.startHeight * ratio) / 2,
				left: (this.mainWidth - this.startWidth * ratio) / 2,
				transform: 'scale('+ratio+')',
				transformOrigin: 'top left',
			});
		}

	});

})(jQuery);
